module.exports = __webpack_public_path__ + "img/home_22.e1158639.png";